/**
 * Construye la query de búsqueda a partir del título y opciones.
 * @param {string} title - Título
 * @param {Object} options - { year, artist } (opcionales)
 * @returns {string} Query para buscar
 */
function buildSearchQuery(title, options = {}) {
  const { year, artist } = options;
  const parts = [title];
  if (year) parts.push(String(year));
  if (artist) parts.push(artist);
  return parts.join(' ');
}

/**
 * Genera la URL de búsqueda en Google para ver info de una película, serie o canción.
 * @param {string} title - Título
 * @param {Object} options - { year, artist } (opcionales)
 * @returns {string} URL para abrir en nueva pestaña
 */
export function getGoogleSearchUrl(title, options = {}) {
  const q = buildSearchQuery(title, options);
  return 'https://www.google.com/search?q=' + encodeURIComponent(q);
}

/**
 * Genera la URL de búsqueda en YouTube Music para una canción o artista.
 * @param {string} title - Título de la canción
 * @param {Object} options - { year, artist } (opcionales)
 * @returns {string} URL de YouTube Music para abrir en nueva pestaña
 */
export function getYouTubeMusicUrl(title, options = {}) {
  const q = buildSearchQuery(title, options);
  return 'https://music.youtube.com/search?q=' + encodeURIComponent(q);
}
